import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { handleActions } from 'redux-actions';
import { reduxKey } from './constants';
import { searchFailure, searchSuccess, searchTags } from './actions';
import { RequestStatus } from './types';
const reducers = handleActions({
    [searchTags.toString()]: (state)=>_object_spread_props(_object_spread({}, state), {
            searchRequestStatus: RequestStatus.Processing
        }),
    [searchSuccess.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            tagSearchResults: action.payload.tags,
            searchRequestStatus: RequestStatus.Success
        }),
    [searchFailure.toString()]: (state)=>_object_spread_props(_object_spread({}, state), {
            tagSearchResults: [],
            searchRequestStatus: RequestStatus.Failure
        })
}, {
    tagSearchResults: [],
    searchRequestStatus: RequestStatus.Success
});
export default {
    [reduxKey]: reducers
};

//# sourceMappingURL=reducer.js.map